import classNames from 'classnames'
import React from 'react'

import { ComponentWithChildrenProps, ComponentWithStyle } from '../../../Common'

export const View = ( { children, className, style }: ComponentWithChildrenProps & ComponentWithStyle ) =>
    <div className={ classNames([ 'px-3 px-md-0 mb-3 position-relative', className ]) } style={ style } >{ children }</div>
